export class NewEnrolmentRequestStudent {
  studentId: string;
  programLevelId: string;
  courseId: string;
  startDate: Date;
  enrolmentType: string;
  enrolInNextTerm: boolean;
  sportsCreditId: string;
}
